import { useCallback, useEffect, useMemo } from 'react';

import StatCard from '../../components/stats/StatCard';
import StatLoader from './StatLoader';

import { useAppDispatch, useAppSelector } from '../../store/hooks';

import { getTourConversionStats } from '../../store/stats/stats-slice';

interface TourConversionProps {
  propertyID: string;
}

const defaultData = {
  title: 'Gross Leases',
  barData: {
    value: 0,
    total: 0
  },
  topData: {
    label: 'YTD Goal',
    value: 0
  },
  bottomData: {
    label: 'YTD Variance',
    value: 0
  }
};

const TourConversion = ({ propertyID }: TourConversionProps): ReactNode => {
  const dispatch = useAppDispatch();
  const tour: any = useAppSelector(
    (state) => state.stats.tours
  );
  const tourConversion: any = useAppSelector(
    (state) => state.stats.tourConversion
  );
  const leases: any = useAppSelector(
    (state) => state.stats.leases
  );
  // console.log('propertyID:', propertyID);

  const selectedPropertyData = useMemo(() => {
    if (tour.isLoading || tourConversion.isLoading || tourConversion.data.length === 0) {
      return defaultData;
    }

    if (
      !propertyID &&
      !tourConversion.isLoading &&
      tourConversion.data.length > 0
    ) {
      return defaultData;
    }

    const selectedData = tourConversion.data.find(
      (property: any) => property.propertyid === propertyID
    );

    if (!selectedData) {
      return defaultData;
    }

    return {
      title: "Gross Leases",
      barData: {
        value: leases?.data?.[0]?.GrossLeases ?? 0,
        total: Math.round(
          (tour?.data?.[0]?.annual_goal ?? 0) * (selectedData.goal_ratio ?? 0)
        )
      },
      topData: {
        label: 'YTD Goal',
        value: Math.round(
          Number(selectedData.goal_ratio ?? 0) * 
          Number(tour?.data?.[0]?.ytd_actual ?? 0)
        ),
      },
      bottomData: {
        label: 'YTD Variance',
        value: 
          Number(leases?.data?.[0]?.GrossLeases ?? 0) - 
          Math.round(Number(selectedData.goal_ratio ?? 0) * 
          Number(tour?.data?.[0]?.ytd_actual ?? 0))
      }
    };
  }, [propertyID, tour, tourConversion]);

  const fetchData = useCallback(async () => {
    try {
      if (!propertyID) {
        return;
      }

      await dispatch(getTourConversionStats(propertyID));
    } catch (error) {
      console.log('error:', error);
    }
  }, [dispatch, propertyID]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <>
      <StatLoader isLoading={tourConversion.isLoading} />
      <StatCard
        data={selectedPropertyData ? selectedPropertyData : defaultData}
      />
    </>
  );
};

export default TourConversion;
